const COUNTRY_CODES = [
  "AF", "AL", "DZ", "AR", "AU", "AT", "BD", "BE", "BR", "CA", "CL", "CN", "CO", "CZ",
  "DK", "EG", "FI", "FR", "DE", "GR", "HK", "HU", "IN", "ID", "IE", "IL", "IT", "JP",
  "KR", "MY", "MX", "NL", "NZ", "NG", "NO", "PK", "PH", "PL", "PT", "RO", "RU", "SA",
  "SG", "ZA", "ES", "SE", "CH", "TW", "TH", "TR", "AE", "GB", "US", "VN"
];

const displayNames = typeof Intl !== "undefined" && Intl.DisplayNames
  ? new Intl.DisplayNames(["en"], { type: "region" })
  : null;

export const COUNTRY_OPTIONS = Array.from(new Set(COUNTRY_CODES))
  .map((code) => ({
    code,
    name: displayNames?.of(code) || code,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const TEMPLATE_TAGS = [
  { tag: "{country_name}", label: "Country name", example: "United States" },
  { tag: "{country_code}", label: "Country code", example: "US" },
  { tag: "{city}", label: "City", example: "New York" },
  { tag: "{timezone}", label: "Timezone", example: "America/New_York" },
  { tag: "{device_type}", label: "Device type", example: "mobile" },
  { tag: "{browser_name}", label: "Browser", example: "Chrome" },
  { tag: "{os_name}", label: "OS", example: "iOS" },
  { tag: "{referrer_domain}", label: "Referrer domain", example: "instagram.com" },
];

export const appendTemplateTag = (value, tag) => `${value || ""}${tag}`;
